import React from "react";

const ExportToExcel = ({ data, filename }) => {
    
    const exportToExcel = () => {
        if (!data || !Array.isArray(data) || data.length === 0) {
            return; // Exit the function early
        }

        // Ensure that the keys are consistent and in the correct order
        const header = Object.keys(data[0]).join(",") + "\n";
        
        // Map each row's values in the correct order and handle null/undefined/objects
        const csv = data.map((item) => 
            Object.keys(item)
                .map((key) => {
                    let value = item[key];
                    
                    if (value == null) return '""';
                    
                    // Keep the safe value processing but add tab
                    let safeValue = '';
                    if (value != null) {
                        safeValue = (typeof value === 'object' && !Array.isArray(value)) ? 
                            JSON.stringify(value) : value.toString();
                    }
                    // Escape quotes
                    safeValue = safeValue.replace(/"/g, '""');
                    
                    // Add tab character for Excel text formatting
                    if ((key === 'BankAccountNo' || key === 'fullfilled') && value != null) {
                        // return `"\t${safeValue}"`;
                        return `"=""${safeValue}"""`;
                    }
                    return `"${safeValue}"`;
                })
                .join(",")
        ).join("\n");
        
        const csvData = header + csv;
        
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        const finalName = (filename && (filename.endsWith('.csv') || filename.endsWith('.xlsx'))) ? filename : `${filename || 'download'}.csv`;
        link.setAttribute("download", finalName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <button className="me-1" id="excel-btn" onClick={exportToExcel}>
            <i className="fa fa-download"></i> 
        </button>
    );
};

export default ExportToExcel;
